import AccordionTab from "components/util/AccordianTab";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { Grid } from "@mui/material";
import {
  allSelectedData,
  resetAllSelectedData,
} from "../../../redux/slices/allSelectedDataSlice";
import { useParams } from "react-router-dom";
import { setValidationErrors } from "../../../redux/slices/formValidationSlice";

const Leasetype: React.FC<Record<any, any>> = (props) => {
  const dispatch = useAppDispatch();
  const selectedData = useAppSelector((state) => state.allSelectedData);
  const status = useAppSelector((state) =>
    state.allSelectedData.leaseStatus.toLowerCase()
  );
  const { formtype } = useParams();
  const handleOptionChange = (event: any) => {
    dispatch(
      allSelectedData({
        leaseId: 0,
        leaseType: event.target.value,
        propertyName: "",
        propertyId: "",
        investmentId: "",
        investmentName: "",
        propertyManager: null,
        secondaryPropertyManager: null,
        tenantId: "",
        tenantName: "",
        leaspropertyManagerNameType: "",
        leasePopupUpdateComments: "",
        lastmodified: "",
        LastModifiedBy: "",
        createdBy: "",
        created: "",
        leaseCommencement: "",
        rentCommencement: "",
        expiration: "",
        nuveenSigningDate: "",
        requestorEmailAddress: "",
        isActive: "",
        unitNumber: "",
        unitSquareFootage: "",
        fileName: "",
        comments: "",
        leaseStatus: "",
        standardTenantName: "",
        naicS_CodeTenant: "",
        xmin: 0,
        leaseActivatedDate: "",
        tenantContactAvailable: "",
        sustainabilityContactAvailable: "",
        abstractStatus: "",
        subjectToSLR: "",
        teamMemberId: "",
      })
    );

    dispatch(setValidationErrors({}));
  };

  return (
    <AccordionTab
      title={"LeaseType"}
      children={
        <div>
          <Grid
            container
            spacing={3}
            justifyContent="center"
            alignItems="center"
          >
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                paddingTop: "14px",
              }}
            >
              <RadioGroup
                row
                aria-label="LeaseType"
                name="LeaseType"
                value={selectedData?.leaseType}
                onChange={handleOptionChange}
                sx={{
                  justifyContent: "center",
                  "& .MuiFormControlLabel-root": {
                    margin: "0 24px",
                  },
                }}
              >
                <FormControlLabel
                  value="New Lease"
                  control={<Radio color="primary" />}
                  label="New Lease"
                  disabled={formtype !== "new"}
                />
                <FormControlLabel
                  value="Lease Amendment"
                  control={<Radio color="primary" />}
                  label="Lease Amendment"
                  disabled={formtype !== "new"}
                />
              </RadioGroup>
            </Grid>
          </Grid>
        </div>
      }
    />
  );
};

export default Leasetype;
